if (!customElements.get('auto-gift')) {
  class AutoGift extends HTMLElement {
    connectedCallback() {
      this.reconcile();
    }

    async reconcile() {
      if (window.__autoGiftBusy) return;

      const available = this.dataset.available === 'true';
      const lineKey = this.dataset.lineKey;
      const qty = Number(this.dataset.qty || 0);
      const eligible = Number(this.dataset.eligibleCount || 0);
      const min = Number(this.dataset.minItems || 1);
      const surplusKeys = (this.dataset.surplusKeys || '')
        .split(',')
        .filter(Boolean);

      let action = null;
      if (!lineKey && eligible >= min && available) {
        action = 'add';
      } else if (lineKey && eligible < min) {
        action = 'remove';
      } else if (lineKey && qty > 1) {
        action = 'cap';
      }

      if (!action && !surplusKeys.length) return;

      window.__autoGiftBusy = true;
      try {
        for (const key of surplusKeys) {
          await this.changeLine(key, 0);
        }
        if (action === 'add') await this.addGift();
        if (action === 'remove') await this.changeLine(lineKey, 0);
        if (action === 'cap') await this.changeLine(lineKey, 1);
        await this.refreshSections();
      } finally {
        window.__autoGiftBusy = false;
      }
    }

    async addGift() {
      const properties = { _auto_gift: '1' };
      if (this.dataset.label) {
        properties['Hediye'] = this.dataset.label;
      }

      const body = JSON.stringify({
        items: [
          {
            id: Number(this.dataset.variantId),
            quantity: 1,
            properties
          }
        ]
      });

      const response = await fetch(`${routes.cart_add_url}`, {
        ...fetchConfig(),
        ...{ body }
      });
      const parsedState = await response.json();

      if (parsedState.status) {
        console.error(parsedState.description);
      }
    }

    async changeLine(key, quantity) {
      const body = JSON.stringify({ id: key, quantity });
      const response = await fetch(`${routes.cart_change_url}`, {
        ...fetchConfig(),
        ...{ body }
      });
      return response.json();
    }

    getSections() {
      const sections = [];

      if (document.getElementById('shopify-section-cart-counter')) {
        sections.push({
          section: 'cart-counter',
          selector: '#shopify-section-cart-counter'
        });
      }

      if (document.getElementById('CartDrawer-Body')) {
        sections.push({
          section: 'cart-drawer',
          selector: '#shopify-section-cart-drawer #CartDrawer-Body'
        });
      }

      const mainCart = document.getElementById('main-cart-items');
      if (mainCart) {
        sections.push({
          section: mainCart.dataset.id,
          selector: `#shopify-section-${mainCart.dataset.id} cart-items`
        });
      }

      return sections;
    }

    async refreshSections() {
      const sections = this.getSections();
      if (!sections.length) return;

      const response = await fetch(
        `${window.location.pathname}?sections=${sections
          .map(section => section.section)
          .join(',')}`
      );
      const parsedSections = await response.json();

      sections.forEach(section => {
        const element = document.querySelector(section.selector);
        if (!element) return;
        const newElement = new DOMParser()
          .parseFromString(parsedSections[section.section], 'text/html')
          .querySelector(section.selector);
        if (newElement) element.innerHTML = newElement.innerHTML;
      });

      if (typeof updateFreeShipping === 'function') updateFreeShipping();
    }
  }

  customElements.define('auto-gift', AutoGift);
}
